import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga';
import Cookies from 'js-cookie';

import { Auth } from 'aws-amplify';
import { Link, withRouter } from 'react-router-dom';
import Routes from './Routes';
import './App.css';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme, makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';
import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import IconButton from '@material-ui/core/IconButton';

const theme = createMuiTheme({
    palette: {
        secondary: {
            main: '#fff', //grey[700] //blue[900]
        },
        primary: {
            // main: indigo[700]
            main: '#DB0030', //'rgb(27,30,126)'
        },
    },
    typography: {
        // Use the system font instead of the default Roboto font. "'Roboto Condensed', sans-serif"
        fontFamily: ['Montserrat', '"Lato"', 'sans-serif'].join(','),
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));
function App(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const smartphone = useMediaQuery('(max-width: 800px)'); //;theme.breakpoints.down('sm'));

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [showCookiesAlert, setShowCookiesAlert] = useState(false);
    const [isAuthenticated, userHasAuthenticated] = useState(false);

    useEffect(() => {
        onLoad();
    }, []);

    async function onLoad() {
        try {
            await Auth.currentSession();
            userHasAuthenticated(true);
        } catch (e) {
            if (e !== 'No current user') {
                alert(e);
            }
        }
        setIsAuthenticating(false);

        var allowCookiesV = Cookies.get('allowCookies');
        if (allowCookiesV === 'true') {
            allowCookies();
        } else if (allowCookiesV === undefined) {
            setShowCookiesAlert(true);
        }
    }

    function currentTab() {
        const currentPath = props.location.pathname;
        if (currentPath === '/') {
            return 0;
        }
        if (currentPath === '/admin') {
            return 1;
        }
        if (currentPath === '/order-management') {
            return 2;
        }
        if (currentPath === '/product-management') {
            return 3;
        }
        // if (currentPath === '/reports') {
        //     return 4;
        // }

        return 0;
    }

    function allowCookies() {
        ReactGA.initialize('UA-130467617-5');
        Cookies.set('allowCookies', 'true', { expires: 2000 });
        setShowCookiesAlert(false);
    }
    function denyCookies() {
        Cookies.set('allowCookies', 'false', { expires: 2000 });
        setShowCookiesAlert(false);
    }

    async function handleLogout() {
        await Auth.signOut();

        userHasAuthenticated(false);

        props.history.push('/login');
    }
    return (
        <ThemeProvider theme={theme}>
            {!isAuthenticating && (
                <div className={classes.root}>
                    {currentTab() !== 0 && (
                        <AppBar position="sticky">
                            <Tabs value={currentTab()} onChange={handleChange} aria-label="Navigation">
                                <Tab
                                    label="Web"
                                    icon={<HomeRoundedIcon />}
                                    component={Link}
                                    to={{
                                        pathname: '/',
                                        search: undefined,
                                    }}
                                />
                                <Tab
                                    label="Admin"
                                    icon={<AccountBalanceRoundedIcon />}
                                    component={Link}
                                    to={{
                                        pathname: '/admin',
                                        search: undefined,
                                    }}
                                />
                                <Tab
                                    label="Gestión de pedidos"
                                    icon={<AllInboxRoundedIcon />}
                                    component={Link}
                                    to={{
                                        pathname: '/order-management',
                                        search: undefined,
                                    }}
                                />
                                <Tab
                                    label="Gestión de productos"
                                    icon={<ListAltRoundedIcon />}
                                    component={Link}
                                    to={{
                                        pathname: '/product-management',
                                        search: undefined,
                                    }}
                                />
                                {/* <Tab
                                    label="Reports"
                                    icon={<AssessmentRoundedIcon />}
                                    component={Link}
                                    to={{
                                        pathname: '/reports',
                                        search: undefined,
                                    }}
                                /> */}
                            </Tabs>
                            <IconButton style={{ position: 'absolute', right: 0, top: '0.7rem' }} onClick={handleLogout} color="inherit" aria-label="Logout">
                                <ExitToAppIcon />
                            </IconButton>
                        </AppBar>
                    )}
                    <Dialog open={showCookiesAlert} maxWidth={'xl'} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Política de cookies</DialogTitle>
                        <DialogContent>
                            <p>
                                Este sitio web utiliza cookies propias y de terceros que almacenan y recuperan información cuando navegas. Con su permiso, CARNES Y ALIMENTOS MAS CRESPO, utilizará
                                cookies con fines analíticos y para mostrarle publicidad personalizada con base en un perfil elaborado a partir de sus hábitos de navegación. Puede hacer clic en el
                                botón “Consentir cookies” para otorgarnos su consentimiento para que llevemos a cabo todo el procesamiento previamente descrito o puede rechazar todas las cookies
                                haciendo clic en el botón “Navegar sin cookies”. En el siguiente enlaze puede consultar nuestra{' '}
                                <a href="https://www.canapaulina.es/aviso-legal.html" target="_blank" rel="noopener noreferrer">
                                    Política de Cookies
                                </a>{' '}
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <Button style={{ margin: '1rem' }} onClick={allowCookies} color="primary" variant="contained">
                                    Consentir cookies
                                </Button>{' '}
                                <Button style={{ margin: '1rem' }} onClick={denyCookies} color="secondary" variant="contained">
                                    Navegar sin cookies
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                    <Routes appProps={{ isAuthenticated, userHasAuthenticated, smartphone }} />
                </div>
            )}
        </ThemeProvider>
    );
    //return <ThemeProvider theme={theme}>{!isAuthenticating && <Routes appProps={{ isAuthenticated, userHasAuthenticated, smartphone }} />}</ThemeProvider>;
}

export default withRouter(App);
